import apiUrl from '../../../constants'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import utils from '../../../utils/validateScanner.js'
import {
  buildConnectionsSearchPayload,
  CONNECTION_SEARCH_PURPOSE,
  getConnectionsSearchUrl
} from '../../../utils/connectionsSearchApi.js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select'

export default {
  name: 'connectionhub',
  mixins: [utils],
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      isLoading: false,

      ConnectionID: '',
      listConnectionNameData: [],
      listConnectionNameDataObj: {
        value: "",
        text: "",
        FullConnectionName: ""
      },
      routetypeitemList: {
        value: "",
        text: ""
      },
      routetypelist: [],
      routetypeitem: {
        id: "",
        text: ""
      },
      routetype: '',

      isSearchConnectionErr: 0,
      SearchConnectionErr: '',
      addmodalShow: false,
      IsActive: false,
      connectionLoading: '',
      actualRouteList: '',
      routetypeListV: '',
      pageCount: 0,
      pageNo: 0,
      totalRows: 0,
      routemode: null,
      listColoaderData: [],
      listColoaderNameDataObj: {
        value: "",
        text: ""
      },
      disableStartTrip:false,
      coloaderID: '',
      coladername: '',
      triptype: null,
      listVehicleData: [],
      listlistVehicleDataObj: {
        id: "",
        text: ""
      },
      VehicleNo: '',
      OpenKm: '',
      cutofflist: [],
      cutoffitem: {
        value: '',
        text: '',
        name: '',
        date: ''
      },
      // markethiredcutofflist: [{
      //   value: null,
      //   text: "Unscheduled",
      //   name: "Unscheduled",
      //   date: "Unscheduled"
      // }],
      coloaderlist: [],
      coloaderitem: {
        value: '',
        text: '',
        route: ''
      },
      coloader: '',
      coloaderLoading: '',
      coloaderError: '',
      cutoff: '',
      CutoffError: '',
      isCutoffError: false,
      IsCutOffPresent: false,
      loginhubid: '',
      scheduledata: {},
      showshedule: false,
      istripFound: false,
      showTripForm: false,
      openkmerror: false,
      vehiclenoerror: false,
      triptypeerror: false,
      tripdata: {},
      tripCreated: false,
      bagNumber: '',
      ScannedBags: [],
      ConfirmConnection: false,
      suggessionData: [],
      selectedColader: {},
      coloaderselecterror: false,
      replacedvehicleno: '',
      replacedvehiclenoerror: false,
      allowreplacevehicle: false,
      allowotherbagmodel: false,
      allowbagmode: '',
      allowbagreason: '',
      allowbagmodeerror: false,
      allowbagreasonerror: false,

      ChangeConnectionRouteModemodel: false,
      ChangeConnectionRouteMode: '',
      ChangeConnectionRouteModereason: '',
      ChangeConnectionRouteModeerror: false,
      ChangeConnectionRouteModereasonerror: false,

      selectedColoader: [],
      coloadermultipleselectionerror: false,
      rejectreason: null,
      currenthubName: '',
      showpendingbags: false,
      pendingBagsListData: [],
      scheduledBagsListData: [],
      rejectreasonerror: false,
      isDisableRejectColoader: false,
      isTripStartedFirst: false,
      validVehicleNoError: false,
      bagNoError: '',
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      showMultipartShipmentModal: false,
      multipartShipmentData: [],
      clientrefData:[],
      multipartDataForConfirmConn: [],
      showMultipartDataForConfirmConn: false,
      timeoutHandler: 0,
      inputString: '',
      manualInput: false,
      hublist: [],
      showemailpage: false,
      emailIdErrorMSG: '',
      emailIdValidationMSG: '',
      mailId: '',
      showPrealert: false,
      isBrook:"",
      regForMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      stateListData:[],
      userData:[],
      vehicleType:[],
      selectedvehicleType: {
        id: "",
        text: ""
      },
      vehicletypeerror:false,
      validreplacedvehiclenoerror:false,
      hubid:'',
      restrictiontype:'outscan',
      // Dock-In related
      dockId: '',
      dockbarcode:'',
      dockList: [],
      selectedDock: { value: '', text: '' },
      scannedDockBarcode: '',
      isDockIn: false,
      dockIdError: false,
      showChangeDockModal: false,
      newDockId: '',
      newDockBarcode:'',
      newDockSelected: { value: '', text: '' },
      newScannedDockBarcode: '',
      newDockIdError: false,
      changeDockReason: '',
      changeDockReasonError: false,
      selectedReasonError: false,
      isDockMandatory:false,
      getDockChangeReasonList:[],
      selectedDockChangeReason:{ value: '', text: '' },
      selectedDockChangeReasonError:"",
      dockLoading: false,
      
    }
  },
  computed: {
    hasScannedDockBarcode() {
      return !!(this.scannedDockBarcode && String(this.scannedDockBarcode).trim().length > 0);
    },
    hasSelectedDockOption() {
      return !!(this.selectedDock && this.selectedDock.value);
    },
    isDockDropdownDisabled() {
      if (this.isDockIn) return true;
      if (!this.hasScannedDockBarcode) return false;
      return !(this.selectedDock && this.selectedDock.value === this.scannedDockBarcode);
    },
    isScanDockBarcodeDisabled() {
      return this.isDockIn || this.hasSelectedDockOption;
    },
    hasNewScannedDockBarcode() {
      return !!(this.newScannedDockBarcode && String(this.newScannedDockBarcode).trim().length > 0);
    },
    hasSelectedNewDockOption() {
      return !!(this.newDockSelected && this.newDockSelected.value);
    },
    isNewDockDropdownDisabled() {
      if (!this.hasNewScannedDockBarcode) return false;
      return !(this.newDockSelected && this.newDockSelected.value === this.newScannedDockBarcode);
    },
    isNewScanDockBarcodeDisabled() {
      return this.hasSelectedNewDockOption;
    },
  },
  watch: {
    isDockMandatory(val) {
      if (val && !this.dockLoading) this.focusScanDockInput();
    },
    dockLoading(val) {
      if (!val && this.isDockMandatory && !this.isDockIn) this.focusScanDockInput();
    },
    showChangeDockModal(val) {
      if (val) this.focusNewDockScanInput();
    },
  },
  created: function() {
    this.$validator.extend('checkopenkm', {
      getMessage: field => `Open KM cannot be less than 10 KM.`,
      validate: value => {
        if (value) {
          if (parseFloat(value) && parseFloat(value) >= 10) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    });
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userData = userdetail;
    this.useremail = userdetail[0].email;
    this.loginhubid = userdetail[0].HubId[0];
    this.hubid = userdetail[0].HubId[0];
    this.getHubName(userdetail[0].HubId);
    this.getHubList();
    this.hubForManualRestriction();
    // this.getDockList();
    this.getIsDockMandatory();
    // user_tracker.checkUserIP(userdetail[0], "CenterScanOut", this.$route.path);
    this.stateListData = window.localStorage.getItem('stateCodeList') ? window.localStorage.getItem('stateCodeList') : [];
  },
  methods: {
    getHubList() {
      this.hublist = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          var HubDetails = result.data.ResponseData
          for (var i = 0; i < HubDetails.length; i++) {
            this.hublist.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
            })
          }
        }, error => {
          console.error(error)
        })
    },
    getRouteType(brook) {
      if(brook=="1"){
        this.routetypelist.push(
          {
           id: 5,
           text: 'BrooksNBonds'
         }
       )
      }
      else{
        this.routetypelist.push(
          {
          id: 1,
          text: 'Local'
        }, {
          id: 3,
          text: 'LineHaul'
        },
         {
          id: 5,
          text: 'BrooksNBonds'
        })
  }},
    selectRouteType(routetypeitem) {
      this.routetypeitem = routetypeitem
      this.routetype = this.routetypeitem.id
      this.listConnectionNameDataObj = {
        text: '',
        value: ''
      }
      this.ConnectionID = ''
      this.listConnectionNameData = [];
      if (this.routetype == 1 || this.routetype == 5) {
        this.routemode = 'Surface';
      }
      if (this.routetype == 5) {
        this.triptype= "brookandbond";
      }
      this.getConnectionListByHubIDAndConnectionType();
      if (this.ConnectionID != '' && this.routetypeitem.id != '') {
        // if (this.routetypeitem.id != 5) {
          this.cutofflist = []
          // this.markethiredcutofflist = [{
          //   value: null,
          //   text: "Unscheduled",
          //   name: "Unscheduled",
          //   date: "Unscheduled"
          // }]
          this.cutoffitem = {
            value: '',
            text: '',
            time: '',
            date: ''
          }
          this.cutoff = ''
          this.CutoffError = ''
          this.isCutoffError = false
          this.IsCutOffPresent = false
          this.getCutOffList();
        // }
      }
      this.coloaderlist = []
      this.coloaderitem = {
        value: '',
        text: '',
        route: ''
      }
      this.coloader = ''
      this.coloaderError = ''
      // if (this.routetypeitem.text == 'Local' && this.listConnectionNameDataObj.text != '' && this.routemode != '') {
      //   this.getColoaderList()
      // }
    },
    selectRouteTypeList(routetypeitemList) {
      this.routetypeitemList = routetypeitemList;
      this.routetypeListV = this.routetypeitemList.id
    },
    selectedHubConnection(selectedData) {
      this.listConnectionNameDataObj = selectedData
      this.ConnectionID = selectedData.value;
      this.ConnectionName = selectedData.text;
      this.actualRoute = selectedData.FullConnectionName;
      if (this.ConnectionID != '' && this.routetypeitem.id != '') {
        // if (this.routetypeitem.id != 5) {
          this.cutofflist = []
          // this.markethiredcutofflist = [{
          //   value: null,
          //   text: "Unscheduled",
          //   name: "Unscheduled",
          //   date: "Unscheduled"
          // }]
          this.cutoffitem = {
            value: '',
            text: '',
            time: '',
            date: ''
          }
          this.cutoff = ''
          this.CutoffError = ''
          this.isCutoffError = false
          this.IsCutOffPresent = false
          this.getCutOffList()
        // }
      }
      this.coloaderlist = []
      this.coloaderitem = {
        value: '',
        text: '',
        route: ''
      }
      this.coloader = ''
      this.coloaderError = ''
      // if (this.routetypeitem.text == 'Local' && this.listConnectionNameDataObj.text != '' && this.routemode != '') {
      //   this.getColoaderList()
      // }
      //  this.loadDisplayRoute()
      //  this.$validator.validate('ConnectionID')
    },

    // toggleSelectColader(selectedData) {
    //   this.listColoaderNameDataObj = selectedData
    //   this.coloaderID = selectedData.value;
    //   this.coladername = selectedData.text;
    // },
    selctedRouteMode() {
      this.coloaderlist = []
      this.coloaderitem = {
        value: '',
        text: '',
        route: ''
      }
      this.coloader = ''
      this.coloaderError = ''
      // if (this.routetypeitem.text == 'Local' && this.listConnectionNameDataObj.text != '' && this.routemode != '') {
      //   this.getColoaderList()
      // }
    },
    toggleSelectColader(data) {
      if (this.selectedColoader.includes(data.LineHaulRateID)) {
        this.selectedColoader.splice(this.selectedColoader.findIndex(v => v === data.LineHaulRateID), 1)
      } else {
        if (this.selectedColoader.length > 0) {
          this.coloadermultipleselectionerror = true;
          this.$alertify.error("You can not select multiple coloaders");
          this.selectedColoader.splice(this.selectedColoader.findIndex(v => v === data.LineHaulRateID), 0);
          return false;
        } else {
          this.coloadermultipleselectionerror = false;
        }
        this.coloaderselecterror = false;
        this.selectedColoader.push(data.LineHaulRateID);
      }
    },
    selectedvehicle(selectedData) {
      this.listlistVehicleDataObj = selectedData
      let vehiclenoarr = this.listlistVehicleDataObj.text.trim().match(/.{0,2}/g);
        if (this.stateListData.length > 0 && !this.stateListData.includes(vehiclenoarr[0].toUpperCase())){
          this.$alertify.error('Error: Invaild Vehicle Number');
          return false;
        }
        this.vehiclenoerror = false;
        if (this.isDockMandatory) {
          this.checkDockIn(this.listlistVehicleDataObj.text);
        }
    },
    selectedvehicletype(selectedData) {
      this.selectedvehicleType = selectedData
        this.vehicletypeerror = false;
    },
    getConnectionListByHubID(searchHubID) {
      this.searchHubID = searchHubID;
      this.getConnectionListByConnectionType();

      this.getConnectionListByHubIDAndConnectionType();
    },
    getConnectionListByConnectionType() {
      this.getConnectionListByHubIDAndConnectionType();
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    //to get Connection List on HubID And ConnectionType
    getConnectionListByHubIDAndConnectionType() {
      this.connectionLoading = 'Loading Connection Name...'
      this.listConnectionNameData = []
      var self = this
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = buildConnectionsSearchPayload(CONNECTION_SEARCH_PURPOSE.LOCAL_LINEHAUL, {
        source: this.loginhubid,
        type: parseInt(self.routetype)
      })
      axios({
          'method': 'POST',
          'url': getConnectionsSearchUrl(),
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.connectionLoading = ''
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            var listConnectionNameData = result.data.ResponseData;
            for (i = 0; i < listConnectionNameData.length; i++) {
              this.listConnectionNameData.push({
                value: listConnectionNameData[i].ConnectionID,
                text: listConnectionNameData[i].ConnectionName,
                FullConnectionName: listConnectionNameData[i].FullConnectionName,
                destinationhubid: listConnectionNameData[i].DestinationHubID
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error("No Connection found")
          }
        }, error => {
          this.$alertify.error("Connection API Error")
          console.error(error)
        })
    },
    loadDisplayRoute() {
      this.actualRoute = "";
      this.input = {
        "ConnectionID": this.ConnectionID
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'loadVendorConnectionRoute',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result) {
            if (result.data.ResultCode == 100) {
              if (result.data.ResponseData.length > 0) {
                this.actualRoute = result.data.ResponseData.join(" - ");
              }
            }
          }
        }, error => {
          console.error(error);
        });
    },

    getColoaderList() {
      this.coloaderLoading = 'Loading Coloader...'
      var coloaderData = []
      this.input = {
        "hubid": this.loginhubid,
        "mode": this.routemode,
        "connectionid": this.ConnectionID
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getColoaderMasterDetails',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.coloaderLoading = ''
          if (result.data.ResultCode == 100) {
            coloaderData = result.data.ResponseData;
            for (var i = 0; i < coloaderData.length; i++) {
              this.coloaderlist.push({
                value: coloaderData[i].coloaderID,
                text: coloaderData[i].coloaderName,
                route: coloaderData[i].coloaderNameWithRouteMode
              })
            }
          } else {
            coloaderData = []
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.coloaderLoading = ''
          this.$alertify.error("Connection API Error")
          console.error(error)
        })
    },
    selectedColoaderName(coloaderitem) {
      this.coloaderitem = coloaderitem
      this.coloader = coloaderitem.text
      if (this.routetypeitem.text == 'Local' && this.coloader == undefined) {
        this.coloaderError = 'The Coloader field is required.'
      } else if (this.routetypeitem.text == 'Local' && this.coloader == '') {
        this.coloaderError = 'The Coloader field is required.'
      } else {
        this.coloaderError = ''
      }
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getconnectionDetails()
    },
    loadpendingbags() {
      var routemode = ''
      if (this.routemode == 'Air') {
        routemode = 'Air'
      } else if (this.routemode == 'Surface' || this.routemode == 'Train') {
        routemode = 'Surface'
      }
      this.pendingBagsListData = []
      var pendingBagsListData = []
      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            console.log('errors exist', this.errors);
            return false;
          } else {
            this.input = {

            }
            axios({
                method: 'GET',
                'url': apiUrl.api_url_hubops + "getPendingBagsForConnection?ConnectionId=" + this.ConnectionID + "&HubId=" + this.loginhubid + "&RouteMode=" + routemode,
                'data': this.input,
                headers: {
                  'authorization': 'authkey xB84JJ89Hd25',
                  'requestfrom': "WEB",
                  'token': this.token
                }
              })
              .then(result => {
                if (result.data.ResultCode == 100) {
                  this.invalidTokenModal = false
                  var pendingBagsListData = result.data.ResponseData;
                  var hubDetails = [];
                  var pendingbagData = [];
                  for (var i = 0; i < this.hublist.length; i++) {
                    hubDetails[this.hublist[i].value] = this.hublist[i].text;
                  }
                  if (pendingBagsListData.length > 0) {
                    pendingBagsListData.forEach(function(item) {
                      item["destinationhubname"] = '';
                      if (item.destinationhubid && hubDetails[item.destinationhubid]) {
                        item["destinationhubname"] = hubDetails[item.destinationhubid];
                      }
                      pendingbagData.push(item);
                    });
                  }
                  this.pendingBagsListData = pendingbagData;

                  this.showpendingbags = true;
                } else if (result.data.ResultCode == 401) {
                  this.invalidTokenModal = true
                  this.invalidtokenmsg = result.data.ReturnMessage
                  this.$alertify.error(result.data.ReturnMessage)
                } else {
                  this.invalidTokenModal = false
                  this.showpendingbags = true;
                  //  this.$alertify.error(result.data.ReturnMessage)
                }

              }, error => {
                this.$alertify.error("API Error")
                console.error(error)
              })
          }
        });
    },
    loadsheduledbags() {
      if (this.scheduledata.connectionschedulemaster !== undefined && this.scheduledata.connectionschedulemaster !== null && this.scheduledata.connectionschedulemaster != '') {
        this.scheduledBagsListData = [];
        var scheduledBagsListData = [];
        axios({
            method: 'GET',
            'url': apiUrl.api_url_hubops + "getScheduledBagsForConnection?ConnectionScheduleMasterId=" + this.scheduledata.connectionschedulemaster + "&HubId=" + this.loginhubid,
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              var scheduledBagsListData = result.data.ResponseData;
              var hubDetails = [];
              var scheduledbagData = [];
              for (var i = 0; i < this.hublist.length; i++) {
                hubDetails[this.hublist[i].value] = this.hublist[i].text;
              }
              if (scheduledBagsListData.length > 0) {
                scheduledBagsListData.forEach(function(item) {
                  item["destinationhubname"] = '';
                  if (item.destinationhubid && hubDetails[item.destinationhubid]) {
                    item["destinationhubname"] = hubDetails[item.destinationhubid];
                  }
                  scheduledbagData.push(item);
                });
              }
              this.scheduledBagsListData = scheduledbagData;

              this.showpendingbags = true;
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              //  this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.$alertify.error("API Error")
            console.error(error)
          })
      } else {
        return false;
      }
    },
    createchedule() {
      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            console.log('errors exist', this.errors);
            return false;
          } else {
            // if (this.routetypeitem.text == 'Local' && this.coloader == undefined) {
            //   this.coloaderError = 'The Coloader field is required.'
            //   return false;
            // } else if (this.routetypeitem.text == 'Local' && this.coloader == '') {
            //   this.coloaderError = 'The Coloader field is required.'
            //   return false;
            // } else {
            //   this.coloaderError = ''
            // }
            var self = this
            var i = 0;
            this.input = {
              connectionType: parseInt(this.routetype),
              connectionId: parseInt(this.ConnectionID),
              connectionName: this.actualRoute,
              routeMode: this.routemode,
              currentHubId: this.loginhubid,
              createdBy: this.useremail,
              destinationHubId: parseInt(this.listConnectionNameDataObj.destinationhubid),
            }
            // if (this.routetypeitem.text == 'Local') {
            //   this.input.coloaderId = this.coloaderitem.value
            // }
            axios({
                method: 'POST',
                'url': apiUrl.api_url_hubops + "createConnectionSchedule",
                'data': this.input,
                headers: {
                  'authorization': 'authkey xB84JJ89Hd25',
                  'requestfrom': "WEB",
                  'token': this.token
                }
              })
              .then(result => {
                if (result.data.ResultCode == 100) {
                  this.invalidTokenModal = false
                  //  this.$alertify.success(result.data.ReturnMessage);
                  this.scheduledata = result.data.ResponseData[0];
                  this.showshedule = true;
                  this.showPrealert = true
                  this.showtripdetails(1);
                  this.loadsheduledbags();
                  this.loadpendingbags();
                  this.showVehicleTypeNameDetails();
                } else if (result.data.ResultCode == 401) {
                  this.invalidTokenModal = true
                  this.invalidtokenmsg = result.data.ReturnMessage
                  this.$alertify.error(result.data.ReturnMessage)
                } else {
                  this.invalidTokenModal = false
                  this.scheduledata = {}
                  this.showPrealert = false
                  this.showshedule = false;
                  //  this.showschedule();
                  this.$alertify.error(result.data.ReturnMessage)
                }
                user_tracker.checkUserIP(this.userData[0], "CenterScanOut_TripSchedule", this.$route.path,this.input);

              }, error => {
                this.$alertify.error("API Error")
                console.error(error)
              })
          }
        }).catch(() => {
          console.log('errors exist', this.errors);
        });
    },
    showtripdetails(value) {
      if (this.showshedule) {
        axios({
            method: 'GET',
            'url': apiUrl.api_url_hubops + "getTripDetailsByConnectionScheduleMasterId?connectionScheduleMasterId=" + this.scheduledata.connectionschedulemaster,
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            //  console.log(result)
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.tripdata = result.data.ResponseData[0]
              this.showTripForm = false;
              this.istripFound = true;
              if (value == 1) {
                this.$alertify.success(result.data.ReturnMessage);
              }
              // this.showschedule();
              // this.scheduledata=result.data.ResponseData[0];
              // this.showshedule=true;
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.tripdata = {}
              this.showTripForm = true;
              this.istripFound = false;
              // this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.$alertify.error("API Error")
            console.error(error)
          })
      }
    },
    showVehicleTypeNameDetails() {
      if (this.showshedule) {
        this.vehicleType = [];
        axios({
            method: 'GET',
            'url': apiUrl.api_url_hubops + "getVehicleType",
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              for (var i = 0; i < result.data.ResponseData.length; i++) {
                let tempObj = {
                  id: result.data.ResponseData[i],
                  text: result.data.ResponseData[i]
                }
                this.vehicleType.push(tempObj);
              }
            }else{
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.$alertify.error("API Error")
            console.error(error)
          })
      }
    },
    getvehiclelist() {
      // if (this.triptype != 'markethired') {
        this.cutofflist = []
        this.cutoffitem = {
          value: '',
          text: '',
          name: '',
          date: ''
        }
        this.cutoff = ''
        this.CutoffError = ''
        this.IsCutOffPresent = false
        this.getCutOffList()
      // }
      // else {
      //   this.cutoffitem = {
      //     value: null,
      //     text: 'Unscheduled',
      //     name: 'Unscheduled'
      //   }
      //   this.cutoff = 'Unscheduled'
      //   this.CutoffError = ''
      //   this.IsCutOffPresent = false
      //   this.markethiredcutofflist = [{
      //     value: null,
      //     text: "Unscheduled",
      //     name: "Unscheduled"
      //   }]
      // }
      this.listVehicleData = [];
      this.listlistVehicleDataObj = {
        value: "",
        text: ""
      }
      this.triptypeerror = false;
      if (this.triptype == 'vendorbased') {
        var VehcilePickFrom = 'regular'
      }
      // else if (this.triptype == 'markethired') {
      //   var VehcilePickFrom = 'market'
      // }
      else {
        return false;
      }
      this.input = {
        "HubId": this.loginhubid,
        "VehcilePickFrom": VehcilePickFrom
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "getVehicleDetailsByHubId",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            var listvehicledata = result.data.ResponseData;
            for (var i = 0; i < listvehicledata.length; i++) {
              this.listVehicleData.push({
                value: listvehicledata[i].VendorVehicleId,
                text: listvehicledata[i].VehicleNumber,
                VendorCompanyId: listvehicledata[i].VendorCompanyId
              })
            }
            // this.showTripForm = false;
            // this.istripFound = true;
            // this.$alertify.success(result.data.ReturnMessage);
            // //   this.showschedule();
            // // this.scheduledata=result.data.ResponseData[0];
            // // this.showshedule=true;
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.$alertify.error("API Error")
          console.error(error)
        })
    },
    createTrip() {
      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            console.log('errors exist', this.errors);
            return false;
          } else {
            let vehiclenoarr = this.VehicleNo.trim().match(/.{0,2}/g);
            if (this.stateListData.length > 0 && !this.stateListData.includes(vehiclenoarr[0].toUpperCase())){
              this.$alertify.error('Error: Invaild Vehicle Number');
              return false;
            }
            if (this.triptype == '' || this.triptype == null) {
              this.triptypeerror = true;
              return false;
            }
            if (this.triptype == 'coloader' || this.triptype == 'brookandbond' || this.triptype == 'markethired') {
              if (this.VehicleNo == '') {
                this.vehiclenoerror = true;
                return false;
              }
              var re = /^([A-Z|a-z]{2}\s{1}[0-9]{1,2}\s{1}[A-Z|a-z]{1,3}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,2}[A-Z|a-z]{1}\s{1}[A-Z|a-z]{2}\s{1}\d{4})?([A-Z|a-z]{3}\s{1}\d{3})?([A-Z|a-z]{2}\s{1}[0-9]{2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,3}\s{1}[A-Z|a-z]{1}\s{1}\d{3,4})?$/;
              if (re.test(this.VehicleNo) == false) {
                this.validVehicleNoError = true;
                return false;
              } else {
                this.validVehicleNoError = false;
              }
            } else {
              if (this.listlistVehicleDataObj.text == '') {
                this.vehiclenoerror = true;
                return false;
              }
            }
            if (this.OpenKm == '') {
              this.openkmerror = true;
              return false;
            }
            if (this.OpenKm <= 0) {
              //this.openkmerror = true;
              return false;
            }
            if (this.selectedvehicleType.text == '' && this.routetype==5) {
              this.vehicletypeerror = true;
              return false;
            }
            if (this.routetypeitem.id != 5 && this.cutoff == '') {
              this.isCutoffError = true
              return false;
            } else {
              this.isCutoffError = false
            }
            if (this.triptype == 'vendorbased') {
              var VehcilePickFrom = 'regular'
              var vehicleno = this.listlistVehicleDataObj.text;
            } else if (this.triptype == 'markethired') {
              var VehcilePickFrom = 'market';
              var vehicleno = this.VehicleNo;
            } else if (this.triptype == 'coloader') {
              var VehcilePickFrom = 'coloader';
              var vehicleno = this.VehicleNo;
            } else {
              var VehcilePickFrom = 'brooks-bonds';
              var vehicleno = this.VehicleNo;
            }
            this.disableStartTrip=true
            if (this.routetypeitem.id == 5) {
              this.input = {
                "ScheduleMasterid": this.scheduledata.connectionschedulemaster,
                "HubID": parseInt(this.loginhubid),
                "RouteMode": this.routemode,
                "ConnectionID": parseInt(this.ConnectionID),
                "ConnectionName": this.actualRoute,
                "VehicleType": VehcilePickFrom,
                "VehicleNo": vehicleno,
                "Openkm": this.OpenKm,
                "Createdby": this.useremail,
                "ConnectionType": parseInt(this.routetype),
                "StatusMarkedFrom": "web",
                "vehicleTypeName" : this.selectedvehicleType.text
              }
            } else {
              this.input = {
                "ScheduleMasterid": this.scheduledata.connectionschedulemaster,
                "HubID": parseInt(this.loginhubid),
                "RouteMode": this.routemode,
                "ConnectionID": parseInt(this.ConnectionID),
                "ConnectionName": this.actualRoute,
                "VehicleType": VehcilePickFrom,
                "VehicleNo": vehicleno,
                "Openkm": this.OpenKm,
                "Createdby": this.useremail,
                "ConnectionType": parseInt(this.routetype),
                "StatusMarkedFrom": "web",
                "CutOffTime": this.cutoffitem.text,
                "CutOffID": this.cutoffitem.value,
                "IsCutOffPresent": this.IsCutOffPresent,
                "CutOffDate": this.cutoffitem.date
              }
            }
            axios({
                method: 'POST',
                'url': apiUrl.api_url_hubops + "createTrip",
                'data': this.input,
                headers: {
                  'authorization': 'authkey xB84JJ89Hd25',
                  'requestfrom': "WEB",
                  'token': this.token
                }
              })
              .then(result => {
                this.disableStartTrip=false
                //  console.log(result)
                if (result.data.ResultCode == 100) {
                  this.invalidTokenModal = false
                  this.tripCreated = true;
                  this.isTripStartedFirst = true;
                  this.tripdata.tripno = result.data.ResponseData.TripID
                  this.tripdata.openkm = this.OpenKm;
                  this.$alertify.success(result.data.ReturnMessage);
                  if (this.isDockMandatory) {
                    let vNo = this.triptype === 'vendorbased' ? this.listlistVehicleDataObj.text : this.VehicleNo;
                    this.checkDockIn(vNo);
                  }
                } else if (result.data.ResultCode == 401) {
                  this.disableStartTrip=false
                  this.invalidTokenModal = true
                  this.invalidtokenmsg = result.data.ReturnMessage
                  this.$alertify.error(result.data.ReturnMessage)
                } else {
                  this.disableStartTrip=false
                  this.invalidTokenModal = false
                  this.isTripStartedFirst = false;
                  this.$alertify.error(result.data.ReturnMessage)
                }
                user_tracker.checkUserIP(this.userData[0], "CenterScanOut_CreateTrip", this.$route.path,this.input);
              }, error => {
                this.$alertify.error("API Error")
                console.error(error)
              })
          }
        })
    },
    resetVehicleForm() {
      this.triptype = null;
      this.OpenKm = '';
      this.VehicleNo = '';
      this.openkmerror = false;
      this.triptypeerror = false;
      this.vehiclenoerror = false;
      this.isTripStartedFirst = false;
      this.validVehicleNoError = false;
      this.listlistVehicleDataObj = {
        value: '',
        text: ''
      }
      this.cutoffitem = {
        value: '',
        text: '',
        time: ''
      },
      this.vehicleType =[]
      this.selectedvehicleType = {
        id: "",
        text: ""
      },
      this.vehicletypeerror =false;
      this.cutoff = ''
      this.CutoffError = ''
      this.isCutoffError = false
      this.IsCutOffPresent = false
    },
    checkvehicleno() {
      if (this.VehicleNo != '') {
        this.vehiclenoerror = false;
      }
    },
    checkvehiclenoselect() {
      if (this.listlistVehicleDataObj.text != '') {
        this.vehiclenoerror = false;
      }
    },
    checkopenkm() {
      if (this.OpenKm != '') {
        this.openkmerror = false;
      }
    },
    getCutOffList() {
      var cutofflist = []
      this.input = {
        "connectionId": parseInt(this.ConnectionID),
        "hubId": this.loginhubid,
        "connectionType": this.routetypeitem.id
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "getCutOff",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.CutoffError = ''
            cutofflist = result.data.ResponseData;
            this.IsCutOffPresent = result.data.IsCutOffPresent
            for (var i = 0; i < cutofflist.length; i++) {
              this.cutofflist.push({
                value: cutofflist[i].CutoffID,
                text: cutofflist[i].CutOffTime,
                name: cutofflist[i].CutoffName,
                date: cutofflist[i].CutOffDate
              })
            }
            if (this.cutofflist.length == 1) {
              for (var i = 0; i < this.cutofflist.length; i++) {
                this.cutoffitem = {
                  value: this.cutofflist[i].value,
                  text: this.cutofflist[i].text,
                  name: this.cutofflist[i].name,
                  date: this.cutofflist[i].date
                }
                this.cutoff = this.cutofflist[i].text
              }
            } else {
              this.cutoffitem = {
                value: '',
                text: '',
                name: '',
                date: ''
              }
              this.cutoff = ''
            }
          } else {
            this.CutoffError = result.data.ReturnMessage
            this.IsCutOffPresent = false
            cutofflist = []
            //this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.$alertify.error("API Error")
          console.error(error)
        })
    },
    selectedCutoff(cutoffitem) {
      this.cutoffitem = cutoffitem
      this.cutoff = cutoffitem.text
      if (this.cutoff == '') {
        this.isCutoffError = true
      } else {
        this.isCutoffError = false
      }
    },
    schedulebag() {
      //  var currenthubname=this.actualRoute.split("(");
      if (this.bagNumber.trim() == '') {
        this.manualInput = false
        this.bagNoError = 'The Bag No field is required.';
        return false;
      } else {
        this.bagNoError = '';
      }
      this.clientrefData=[];
      this.input = {
        "connectionScheduleMasterId": this.scheduledata.connectionschedulemaster,
        "currentHubId": parseInt(this.loginhubid),
        "routeMode": this.routemode,
        "bagNumber": this.bagNumber.trim(),
        "connectionId": parseInt(this.ConnectionID),
        "currentHubName": this.currenthubName,
        "invoiceNo": this.scheduledata.invoiceno,
        "createdBy": this.useremail,
        "isManualEntry": this.manualInput
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "scheduleBag",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            //  this.tripCreated = true;
            this.ScannedBags.push(this.bagNumber);
            this.$alertify.success(result.data.ReturnMessage);

            this.cancelID();
            this.loadsheduledbags();
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 110) {
            this.multipartShipmentData = result.data.ResponseData
            this.showMultipartShipmentModal = true
            this.$alertify.error(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 113) {
            this.clientrefData = result.data.ResponseData
            this.showMultipartShipmentModal = true
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
          user_tracker.checkUserIP(this.userData[0], "CenterScanOut_ScheduleBag", this.$route.path,this.input);
        }, error => {
          this.$alertify.error("API Error")
          console.error(error)
        })
    },
    clearError() {
      if (this.bagNumber.trim() == '') {
        this.manualInput = false
        this.bagNoError = 'The Bag No field is required.';
      } else {
        this.bagNoError = '';
      }
    },
    closeModal() {
      this.showMultipartShipmentModal = false;
      this.multipartShipmentData = [];
      this.clientrefData =[];
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    closeModalForConConn() {
      this.showMultipartDataForConfirmConn = false;
      this.multipartDataForConfirmConn = [];
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    cancelID() {
      this.bagNumber = ''
      this.manualInput = false
      this.bagNoError = ''
    },
    onSubmit: function() {
      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            console.log('errors exist', this.errors);
            return false;
          } else {
            this.saveHubConnectionMapping();
          }
        }).catch(() => {
          console.log('errors exist', this.errors);
        });
    },
    getlhcosuggestion() {
      this.selectedColoader = [];
      if (this.routetype == 1 || this.routetype == 5) {
        return false;
      } else if (this.ConfirmConnection == true) {
        this.input = {
          "hubId": parseInt(this.loginhubid),
          "routeMode": this.routemode,
          "connectionId": parseInt(this.ConnectionID),
          "createdBy": this.useremail
        }
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + "lhcoSuggestionByHubId",
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            //    console.log(result)
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.suggessionData = result.data.ResponseData;
              if (this.suggessionData.length > 0) {
                this.selectedColoader.push(this.suggessionData[0].LineHaulRateID)
              }
              if (this.suggessionData.length == 1) {
                this.isDisableRejectColoader = true;
              } else {
                this.isDisableRejectColoader = false;
              }
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.$alertify.error("API Error")
            console.error(error)
          })
      }
    },
    // selectcoloader(data){
    //     this.selectedColader=data;
    //     this.coloaderselecterror=false;
    //   //  console.log(this.selectedColader)
    // },
    ConfirmConnectionSave() {
      if (this.selectedColoader.length == 0 && this.routetype == 3) {
        this.coloaderselecterror = true;
        return false;
      }
      var currenthubname = this.actualRoute.split("(");
      if (this.routetype == 3) {
        this.isLoading = true
        var selectedColoaderData = this.suggessionData.filter(obj => obj.LineHaulRateID == this.selectedColoader[0]);
        var url = apiUrl.api_url_hubops + "confirmConnection";
        this.input = {
          "connectionScheduleMasterId": parseInt(this.scheduledata.connectionschedulemaster),
          "lhTrainFlightDetailsId": parseInt(selectedColoaderData[0].LHTrainFlightDetailsId),
          "connectionId": parseInt(this.ConnectionID),
          "coloaderId": parseInt(selectedColoaderData[0].ColoaderID),
          "currentHubId": parseInt(this.loginhubid),
          "currentHubName": this.currenthubName,
          "createdBy": this.useremail,
          "coloaderName": selectedColoaderData[0].ColoaderName,
          "lineHaulRateId": parseInt(selectedColoaderData[0].LineHaulRateID)
        }
      } else {
        var url = apiUrl.api_url_hubops + "confirmLocalConnection";
        this.input = {
          "connectionScheduleMasterId": parseInt(this.scheduledata.connectionschedulemaster),
          "connectionId": parseInt(this.ConnectionID),
          "currentHubId": parseInt(this.loginhubid),
          "currentHubName": this.currenthubName,
          "createdBy": this.useremail
        }
      }
      //  console.log(this.input) ; return false;
      axios({
          method: 'POST',
          'url': url,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.isLoading = false
            this.invalidTokenModal = false
            //  this.suggessionData = result.data.ResponseData;
            this.$alertify.success(result.data.ReturnMessage);
            this.resetForm();
          } else if (result.data.ResultCode == 401) {
            this.isLoading = false
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 110) {
            this.isLoading = false
            this.showMultipartDataForConfirmConn = true
            this.multipartDataForConfirmConn = result.data.ResponseData
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.isLoading = false
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
          user_tracker.checkUserIP(this.userData[0], "CenterScanOut_ConfirmConnection", this.$route.path,this.input);
        }, error => {
          this.$alertify.error("API Error")
          console.error(error)
        })
    },
    allowreplace() {
      this.allowreplacevehicle = true;
    },
    replacedvehiclenocheckfunction() {
      if (this.replacedvehicleno != '') {
        this.replacedvehiclenoerror = false;
      }
    },
    replecevehicle() {
      this.validreplacedvehiclenoerror = false;
      if (this.replacedvehicleno == '') {
        this.replacedvehiclenoerror = true;
        return false;
      }else{
        var re = /^([A-Z|a-z]{2}\s{1}[0-9]{1,2}\s{1}[A-Z|a-z]{1,3}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,2}[A-Z|a-z]{1}\s{1}[A-Z|a-z]{2}\s{1}\d{4})?([A-Z|a-z]{3}\s{1}\d{3})?([A-Z|a-z]{2}\s{1}[0-9]{2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,3}\s{1}[A-Z|a-z]{1}\s{1}\d{3,4})?$/;
        if (re.test(this.replacedvehicleno) == false) {
          this.validreplacedvehiclenoerror = true;
          return false;
        }
      }

      this.input = {
        tripId: parseInt(this.tripdata.tripno),
        vehicleNo: this.replacedvehicleno,
        tripType: this.tripdata.triptype,
        createdBy: this.useremail
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "vehicleReplacement",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          //  console.log(result)
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.$alertify.success(result.data.ReturnMessage);
            this.showtripdetails();
            this.resetreplacevehicle();
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.$alertify.error("API Error")
          console.error(error)
        })
    },
    resetreplacevehicle() {
      this.allowreplacevehicle = false;
      this.replacedvehiclenoerror = false;
      this.validreplacedvehiclenoerror = false;
      this.replacedvehicleno = "";
    },
    allowotherbag() {
      this.allowotherbagmodel = true;
    },
    closeallowotherbagmodel() {
      this.allowotherbagmodel = false;
      this.allowbagmodeerror = false;
      this.allowbagreasonerror = false;
      this.allowbagmode = '';
      this.allowbagreason = '';
    },
    allowotherbagsave() {
      if (this.allowbagmode == null || this.allowbagmode == '') {
        this.allowbagmodeerror = true;
        return false;
      }
      if (this.allowbagreason == null || this.allowbagreason == '') {
        this.allowbagreasonerror = true;
        return false;
      }
      this.input = {
        "ConnectionScheduleMasterID": parseInt(this.scheduledata.connectionschedulemaster),
        "LastModifiedBy": this.useremail,
        "RouteModeAllowReason": this.allowbagreason,
        "AllowRouteMode": this.allowbagmode,
        "IsAllowOtherRouteMode": true
      }
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + "connectionScheduleAllowOtherRouteMode",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.allowbagmode = '';
            this.allowbagreason = '';
            this.allowotherbagmodel = false;
            this.$alertify.success(result.data.ReturnMessage);
            this.createchedule();
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.$alertify.error("API Error")
          console.error(error)
        })
    },

    checkmode() {
      if (this.allowbagmode != null || this.allowbagmode != '') {
        this.allowbagmodeerror = false
      }
    },
    checkreason() {
      if (this.allowbagreason != null || this.allowbagreason != '') {
        this.allowbagreasonerror = false
      }
    },
    ChangeConnectionRouteModeFunction() {
      this.ChangeConnectionRouteModemodel = true;
    },
    closeChangeConnectionRouteModemodel() {
      this.ChangeConnectionRouteModemodel = false;
      this.ChangeConnectionRouteModeerror = false;
      this.ChangeConnectionRouteModereasonerror = false;
      this.ChangeConnectionRouteMode = '';
      this.ChangeConnectionRouteModereason = '';
    },
    ChangeConnectionRouteModesave() {
      if (this.ChangeConnectionRouteMode == null || this.ChangeConnectionRouteMode == '') {
        this.ChangeConnectionRouteModeerror = true;
        return false;
      }
      if (this.ChangeConnectionRouteModereason == null || this.ChangeConnectionRouteModereason == '') {
        this.ChangeConnectionRouteModereasonerror = true;
        return false;
      }
      this.input = {
        "ConnectionScheduleMasterId": parseInt(this.scheduledata.connectionschedulemaster),
        "ConnectionID": parseInt(this.ConnectionID),
        "RouteMode": this.scheduledata.routemode,
        "AllowRouteMode": this.ChangeConnectionRouteMode,
        "ConnectionRouteModeChangeReason": this.ChangeConnectionRouteModereason,
        "ProcessLocationName": this.currenthubName,
        "LastModifiedBy": this.useremail
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "updateScheduledConnectionRouteMode",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.ChangeConnectionRouteMode = '';
            this.ChangeConnectionRouteModereason = '';
            this.ChangeConnectionRouteModemodel = false;
            this.$alertify.success(result.data.ReturnMessage);
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.$alertify.error("API Error")
          console.error(error)
        })
    },
    CancelCurrentSchedule() {
      this.input = {
        "ConnectionScheduleMasterId": parseInt(this.scheduledata.connectionschedulemaster),
        "LastModifiedBy": this.useremail,
        "ProcessLocation": parseInt(this.loginhubid),
        "ProcessLocationName": this.currenthubName,
        "TripId": parseInt(this.tripdata.tripno),
        "CloseKm": parseInt(this.tripdata.openkm)
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "cancelCurrentSchedule",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.resetForm();
            this.scheduledata = {};
            this.showPrealert = false
            this.closeChangeConnectionRouteModemodel();
            this.$alertify.success(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.$alertify.error("API Error")
          console.error(error)
        })
    },
    checkChangeConnectionRouteMode() {
      if (this.ChangeConnectionRouteMode != null || this.ChangeConnectionRouteMode != '') {
        this.ChangeConnectionRouteModeerror = false
      }
    },
    checkChangeConnectionRouteModereason() {
      if (this.ChangeConnectionRouteModereason != null || this.ChangeConnectionRouteModereason != '') {
        this.ChangeConnectionRouteModereasonerror = false
      }
    },
    checkrejectreason() {
      if (this.rejectreason != '' && this.rejectreason != null) {
        this.rejectreasonerror = false;
      } else {
        this.rejectreasonerror = true;
      }
    },
    rejectcoloader(data, index) {
      if (this.rejectreason == null || this.rejectreason == '') {
        this.rejectreasonerror = true;
        return false;
      }
      this.input = {
        "ConnectionScheduleMasterId": parseInt(this.scheduledata.connectionschedulemaster),
        "ConnectionID": parseInt(this.ConnectionID),
        "ColoaderId": parseInt(data.ColoaderID),
        "ColoaderName": data.ColoaderName,
        "RouteMode": this.routemode,
        "LHTrainFlightDetailsId": parseInt(data.LHTrainFlightDetailsId),
        "RejectReason": this.rejectreason,
        "LineHaulRateId": data.LineHaulRateID === undefined ? 0 : parseInt(data.LineHaulRateID),
        "createdBy": this.useremail,
        "rate":data.Rate
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "insertRejectedColoaderReasonLog",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          //  console.log(result)
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.selectedColoader.splice(this.selectedColoader.findIndex(v => v === data.LineHaulRateID), 1);
            this.$alertify.success(result.data.ReturnMessage);
            this.rejectreason = null;
            //console.log((Number(index)+1))
            if ((Number(index) + 1) < this.suggessionData.length) {
              this.selectedColoader.push(this.suggessionData[Number(index) + 1].LineHaulRateID)
            }
            if ((this.suggessionData.length - 1) == (Number(index) + 1)) {
              this.isDisableRejectColoader = true;
            } else {
              this.isDisableRejectColoader = false;
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.$alertify.error("API Error")
          console.error(error)
        })
    },
    resetFormFinal() {
      this.isLoading=false
      this.disableStartTrip=false
      this.scheduledata = {}
      this.showPrealert = false
      this.resetForm();
    },
    resetForm() {
      this.listConnectionNameDataObj = {
        value: '',
        text: ''
      };
      this.listColoaderNameDataObj = {
        value: '',
        text: ''
      };
      this.routetypeitem = {
          id: '',
          text: ''
        },
        //this.listconeectionDetails = '';
        this.routetype = '';
      this.connectiontype = '';
      this.connectionname = '';
      this.resultHubID = '';
      this.ConnectionID = '';
      this.DesHubID = '';
      this.routemode = null;
      this.listColoaderNameDataObj = {
        value: '',
        text: ''
      };
      this.showshedule = false;
      this.istripFound = false;
      this.showTripForm = false;
      this.openkmerror = false;
      this.vehiclenoerror = false;
      this.triptypeerror = false;
      this.tripdata = {};
      this.tripCreated = false;
      this.bagNumber = '';
      this.manualInput = false
      this.ScannedBags = [];
      this.ConfirmConnection = false;
      this.suggessionData = [];
      //  this.selectedColader={};
      this.coloaderselecterror = false;
      this.replacedvehiclenoerror = false;
      this.replacedvehicleno = "";
      this.allowreplacevehicle = false;
      this.selectedColoader = [];
      this.coloadermultipleselectionerror = false;
      this.showpendingbags = false;
      this.pendingBagsListData = [];
      this.scheduledBagsListData = [];
      this.triptype = null;
      this.OpenKm = '';
      this.VehicleNo = '';
      this.listlistVehicleDataObj = {
        value: '',
        text: ''
      };
      this.bagNoError = '';
      this.openkmerror = false;
      this.triptypeerror = false;
      this.vehiclenoerror = false;
      this.isDisableRejectColoader = false;
      this.isTripStartedFirst = false;
      this.validVehicleNoError = false;
      this.coloaderlist = []
      this.coloaderitem = {
        value: '',
        text: '',
        route: ''
      },
      this.vehicleType =[]
      this.selectedvehicleType = {
        id: "",
        text: ""
      },
      this.vehicletypeerror =false;
      this.coloader = ''
      this.coloaderError = ''
      this.validreplacedvehiclenoerror = false;
      this.$validator.reset();
      //reset Dock
      // Replace the inline dock reset block at end of resetForm() with:
      this.resetDock();
      this.isDockIn = false;
      this.newDockBarcode = '';
      this.newDockId = '';

    },
    getHubName(hubid) {
      this.input = {
        hubids: hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.currenthubName = result.data.ResponseData[0].HubName;
            this.isBrook = result.data.ResponseData[0].ConfigSetting.isbrook;
            this.getRouteType(this.isBrook);
          } else {
            this.currenthubName = '';
          }
        }, error => {
          console.error(error)
        })
    },
    removeBagFromSchedule(data) {
      this.input = ({
        "parentBagNo": data.bagno.trim(),
        "lastModifiedBy": this.useremail,
        "userHubID": this.loginhubid,
        "processLocationName": this.currenthubName,
        "connectionType": parseInt(this.routetype)
      })
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'removeBagLinehaulAndLocal',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.$alertify.success(result.data.ReturnMessage)
              this.loadsheduledbags()
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          },
          error => {
            console.error(error)
          })
    },
    sendMail() {
      this.showemailpage = true;
    },
    closeSendMailPage() {
      this.showemailpage = false;
      this.viewBagListmodel = false
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.resetFormForMail();
    },
    resetFormForMail() {
      this.mailId = '',
        this.emailIdErrorMSG = '',
        this.emailIdValidationMSG = ''
    },
    SendMailFunction() {
      this.emailIdValidationMSG = ''
      this.emailIdErrorMSG = ''
      if (this.mailId == '' || this.mailId == undefined) {
        this.emailIdErrorMSG = "Enter Email-Id"
        return false
      }
      var mailArray = [];
      mailArray = this.mailId.split(',');
      for (var i = 0; i < mailArray.length; i++) {
        if (this.regForMail.test(mailArray[i]) == false) {
          this.emailIdValidationMSG = "Invalid MailId" + " " + mailArray[i]
          return false
        }
      }
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'emailBagDetailsForGenerateInvoice?invoiceNo=' + this.scheduledata.invoiceno + '&emailId=' + this.mailId + '&createdBy=' + this.useremail,
        data: this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      }).then(result => {
        var response = result.data
        if (response.ResultCode == 100) {
          this.$alertify.success(response.ReturnMessage)
          this.closeSendMailPage()
        } else {
          this.$alertify.error(response.ReturnMessage)
        }
        this.isLoading = false
      }, error => {
        this.isLoading = false
        console.error(error)
      })

    },
   

  getIsDockMandatory(){
    this.dockLoading = true;
     axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/isDockMandatory?hubId=' + this.loginhubid,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      }).then(result => {
        if (result.data.ResultCode == 100) {
         this.isDockMandatory = result.data.ResponseData.is_mandatory
         if(this.isDockMandatory){
          this.getDockList();
         } else {
          this.dockLoading = false;
         }
        }
        else{
          this.dockLoading = false;
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => { console.error(error);
        this.dockLoading = false;
      });

  },
  
  getDockList() {
      this.dockList = [];
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/dockList?hubId=' + this.loginhubid,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      }).then(result => {
        this.dockLoading = false;
        if (result.data.ResultCode == 100) {
          result.data.ResponseData.forEach(item => {
            this.dockList.push({ value: item.dock_barcode, text: item.dock_id });
          });
        }
        else{
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => { console.error(error);
        this.dockLoading = false;
      });
    },

      getDockChangeReason() {
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/dockReasons?type=dock_change_reasons',
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      }).then(result => {
        console.log("result",result)
        if (result.data.ResultCode == 100) {
          this.getDockChangeReasonList = result.data.ResponseData.map(r => ({ value: r.id, text: r.reason }));
        }
        else{
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => { console.error(error); });
    },

    selectDock(selectedData) {
      this.selectedDock = selectedData;
      this.dockId = selectedData.text;
      this.dockbarcode = selectedData.value;
      this.scannedDockBarcode = selectedData.value;
      this.dockIdError = false;
    },

    onDockBarcodeScan() {
      const value = this.scannedDockBarcode ? String(this.scannedDockBarcode).trim() : '';
      if (!value) {
        this.dockbarcode = '';
        this.dockId = '';
        this.selectedDock = { value: '', text: '' };
        return;
      }
      // Case-insensitive local lookup so casing / trailing-whitespace differences from the scanner do not break the mapping.
      const normalized = value.toLowerCase();
      const match = this.dockList.find(d => String(d.value).trim().toLowerCase() === normalized);
      if (match) {
        this.dockbarcode = match.value;
        this.dockId = match.text;
        this.selectedDock = { value: match.value, text: match.text };
        this.scannedDockBarcode = match.value;
        this.dockIdError = false;
        return;
      }
      // Fallback: dockList may be stale or missing entries for LHCO scheduling; resolve barcode -> dock_id via backend.
      this.dockbarcode = value;
      this.dockId = '';
      this.selectedDock = { value: '', text: '' };
      this.dockIdError = false;
      this.validateBarcode(value, 'primary');
    },

    focusScanDockInput() {
      this.$nextTick(() => {
        if (this.$refs.scanDockInput && typeof this.$refs.scanDockInput.focus === 'function') {
          this.$refs.scanDockInput.focus();
        }
      });
    },

    focusNewDockScanInput() {
      this.$nextTick(() => {
        if (this.$refs.scanNewDockInput && typeof this.$refs.scanNewDockInput.focus === 'function') {
          this.$refs.scanNewDockInput.focus();
        }
      });
    },

    onNewDockBarcodeScan() {
      const value = this.newScannedDockBarcode ? String(this.newScannedDockBarcode).trim() : '';
      if (!value) {
        this.newDockBarcode = '';
        this.newDockId = '';
        this.newDockSelected = { value: '', text: '' };
        return;
      }
      const normalized = value.toLowerCase();
      const match = this.dockList.find(d => String(d.value).trim().toLowerCase() === normalized);
      if (match) {
        this.newDockBarcode = match.value;
        this.newDockId = match.text;
        this.newDockSelected = { value: match.value, text: match.text };
        this.newScannedDockBarcode = match.value;
        this.newDockIdError = false;
        return;
      }
      this.newDockBarcode = value;
      this.newDockId = '';
      this.newDockSelected = { value: '', text: '' };
      this.newDockIdError = false;
    },

    checkDockIn(vehicleNumber) {
      if (!vehicleNumber) {
        // HUB: never leave the dock loader stuck if we bail out before firing the request
        this.dockLoading = false;
        return;
      }
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/checkDockIn?hubId=' + this.loginhubid + '&vehicleNumber=' + vehicleNumber,
        headers: { 'authorization': 'authkey xB84JJ89Hd25' }
      }).then(result => {
        // HUB: clear loader here too so the dock section renders even if getDockList() hangs or errors
        this.dockLoading = false;
        if (result.data.ResultCode == 100 && result.data.ResponseData.is_docked_in) {
          this.dockbarcode = result.data.ResponseData.dock_barcode;
          this.dockId = result.data.ResponseData.dock_id;
          this.selectedDock = { value: result.data.ResponseData.dock_barcode, text: result.data.ResponseData.dock_id };
          // HUB: retain the auto-loaded scanned barcode in the input when returning to the page after dock-in
          this.scannedDockBarcode = result.data.ResponseData.dock_barcode;
          this.isDockIn = true;
          this.$alertify.success("Already Dock-In at " + result.data.ResponseData.dock_barcode);
        }
      }, error => {
        this.dockLoading = false;
        console.error(error);
      });
    },

    validateBarcode(barcode, target /* 'primary' | 'new' */) {
      return new Promise((resolve) => {
        if (!barcode) { resolve({ ok: false, reason: 'empty' }); return; }
        axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'dockmaster/validateBarcode',
          data: {
            dock_barcode: String(barcode).trim(),
            hub_id: Number(this.loginhubid),
          },
          headers: { 'authorization': 'authkey xB84JJ89Hd25' }
        }).then(result => {
          const data = (result && result.data) || {};
          const resp = data.ResponseData || {};
          if (data.ResultCode == 100 && resp.dock_id) {
            // Populate target vars whenever the barcode resolves to a
            // real dock at this hub (even at full capacity). Capacity
            // enforcement is signalled via `ok: false, reason: 'full'`
            // so click-time callers still early-abort on full docks.
            // See sibling `CenterScanInTrip.validateBarcode` for the
            // full rationale.
            if (target === 'primary') {
              this.dockbarcode = barcode;
              this.dockId = resp.dock_id;
              this.selectedDock = { value: barcode, text: resp.dock_id };
              this.scannedDockBarcode = barcode;
              this.dockIdError = false;
            } else {
              this.newDockBarcode = barcode;
              this.newDockId = resp.dock_id;
              this.newDockSelected = { value: barcode, text: resp.dock_id };
              this.newScannedDockBarcode = barcode;
              this.newDockIdError = false;
            }
            if (resp.is_available === false) {
              this.$alertify.error(data.ReturnMessage || 'Dock is at full capacity.');
              resolve({ ok: false, valid: true, reason: 'full', dock_id: resp.dock_id });
              return;
            }
            resolve({ ok: true, valid: true, dock_id: resp.dock_id });
          } else {
            this.$alertify.error(data.ReturnMessage || 'Invalid dock barcode.');
            resolve({ ok: false, valid: false, reason: 'invalid' });
          }
        }, err => {
          console.error(err);
          this.$alertify.error('Dock barcode validation failed.');
          resolve({ ok: false, valid: false, reason: 'error' });
        });
      });
    },

    async dockIn() {
      if (!this.dockbarcode) {
        this.dockIdError = true;
        return;
      }

      const { ok: isValid } = await this.validateBarcode(this.dockbarcode, 'primary');
      if (!isValid) return;

      console.log("tripdata",this.tripdata)
      let vehicleNumber;
     
     
      if(this.triptype === 'vendorbased'){
        vehicleNumber = this.listlistVehicleDataObj.text || this.tripdata.vehicleno
      }
      else{
        vehicleNumber = this.VehicleNo || this.tripdata.vehicleno
      }
      this.input = { 
        dock_barcode: this.dockbarcode, 
        hub_id: this.loginhubid, 
        vehicle_number:vehicleNumber,
        operation_type:"Midmile_Outbound",
        trip_id:this.tripdata.tripno.toString(),
        dock_in_by:this.useremail,
        override_reason:""
        };
        console.log("input",this.input)
      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'dockmaster/dockIn',
        data: this.input,
        headers: { 'authorization': 'authkey xB84JJ89Hd25'}
      }).then(result => {
        if (result.data.ResultCode == 100) {
          this.isDockIn = true;
          this.$alertify.success(result.data.ReturnMessage);
        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }
      }, error => { this.$alertify.error('Dock-In API Error'); });
    },

    openChangeDockModal() {
      this.getDockChangeReason();
      this.getDockList();
      this.showChangeDockModal = true;
      this.newDockId = '';
      this.newDockBarcode = '';
      this.newDockSelected = { value: '', text: '' };
      this.newScannedDockBarcode = '';
      this.changeDockReason = '';
      this.selectedDockChangeReason = { value: '', text: '' };
      this.selectedDockChangeReasonError = '';
      this.newDockIdError = false;
      this.changeDockReasonError = false;
    },


    closeChangeDockModal() {
      this.showChangeDockModal = false;
    },

    selectNewDock(selectedData) {
      this.newDockSelected = selectedData;
      this.newDockId = selectedData.text;
      this.newDockBarcode = selectedData.value;
      this.newScannedDockBarcode = selectedData.value;
      this.newDockIdError = false;
    },

    selectReasonForNewDock(selectedData) {
      this.selectedDockChangeReason = selectedData;
      console.log("selected",this.selectedReason)
      this.selectedDockChangeReasonError = false;
    },

    async saveDockChange() {
      // Validate all required fields
      let isValid = true;

      if (!this.newDockBarcode || this.newDockBarcode === '') {
        this.newDockIdError = true;
        isValid = false;
      }

      if (!this.selectedDockChangeReason || !this.selectedDockChangeReason.value) {
        this.selectedDockChangeReasonError = true;
        isValid = false;
      }

      if (!isValid) return;

      const { ok: isDockValid } = await this.validateBarcode(this.newDockBarcode, 'new');
      if (!isDockValid) return;

      let vehicleNumber;
     

      if(this.triptype === 'vendorbased'){
        vehicleNumber = this.listlistVehicleDataObj.text || this.tripdata.vehicleno
      }
      else{
        vehicleNumber = this.VehicleNo || this.tripdata.vehicleno
      }

      this.input = {
        vehicle_number: vehicleNumber,
        new_dock_barcode: this.newDockBarcode,
        hub_id: this.loginhubid,
        modifiedBy: this.useremail,
        reason:this.selectedDockChangeReason.text,
        status_marked_from: 'WEB'

      };

      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'dockmaster/changeDock',
        data: this.input,
        headers: { 'authorization': 'authkey xB84JJ89Hd25'}
      }).then(result => {
        if (result.data.ResultCode == 100) {
          this.dockId = this.newDockId;
          this.dockbarcode = this.newDockBarcode;
          this.scannedDockBarcode = this.newDockBarcode;
          this.selectedDock = { value: this.newDockBarcode, text: this.newDockId };
          this.showChangeDockModal = false;
          this.$alertify.success(result.data.ReturnMessage);
          this.resetChangeDockForm();
        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }
      }, error => { this.$alertify.error('Change Dock API Error'); });
    },

  resetChangeDockForm() {
      this.newDockId = '';
      this.newDockBarcode = '';
      this.newDockSelected = { value: '', text: '' };
      this.newScannedDockBarcode = '';
      this.selectedDockChangeReason = { value: '', text: '' };
      this.selectedDockChangeReasonError = '';
      this.changeDockReason = '';
      this.newDockIdError = false;
      this.changeDockReasonError = false;
      if (this.showChangeDockModal) this.focusNewDockScanInput();
    },

 resetDock() {
  this.selectedDock = { value: '', text: '' };
  this.dockId = '';
  this.dockbarcode = '';
  this.scannedDockBarcode = '';
  this.dockIdError = false;
  if (this.isDockMandatory) this.focusScanDockInput();
}
}
}



// WEBPACK FOOTER //
// ./src/views/components/CenterScanOut/Centerscanout.component.js